
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IKPIResult } from '../../shared/contracts/KPIContract';
@Component({})
export default class DriverBreakdown extends Vue {
    @Prop() result: IKPIResult;
    @Prop({default: false}) useText: boolean;
}
